import { lazy } from 'react';

/**
 * Os gráficos, carregados sob demanda.
 *
 * NÃO é otimização especulativa: `HomeDashboard` é importado eagerly em
 * CRM.tsx, então importar recharts direto de um bloco coloca ~450 KB de
 * biblioteca no chunk de ENTRADA — no caminho do primeiro paint de todo mundo
 * que faz login, antes da saudação aparecer.
 *
 * Com lazy, a página desenha e o gráfico preenche depois. O `Suspense` de cada
 * bloco reserva a altura pra nada pular quando ele chega.
 */
export const BarraMensal = lazy(() =>
  import('./BarraMensal').then((m) => ({ default: m.BarraMensal })),
);

export const CurvaMes = lazy(() =>
  import('./CurvaMes').then((m) => ({ default: m.CurvaMes })),
);

export const CurvaMeses = lazy(() =>
  import('./CurvaMeses').then((m) => ({ default: m.CurvaMeses })),
);
